import type { Money } from './model';

export const INT64_MIN = -(1n << 63n);
export const INT64_MAX = (1n << 63n) - 1n;

export function assertMoney(value: bigint): Money {
  if (value < INT64_MIN || value > INT64_MAX) throw new RangeError('Valor fora do intervalo de Int64.');
  return value;
}

export function addMoney(left: Money, right: Money): Money {
  return assertMoney(left + right);
}

export function parseBRL(input: string): Money {
  const compact = input.trim().replace(/\s/g, '').replace(/^R\$/i, '');
  if (!compact) throw new Error('Informe um valor.');
  const normalized = compact.includes(',')
    ? compact.replace(/\./g, '').replace(',', '.')
    : compact;
  if (!/^-?\d+(?:\.\d{1,2})?$/.test(normalized)) throw new Error('Use um valor em reais, como 85,60.');
  const negative = normalized.startsWith('-');
  const unsigned = negative ? normalized.slice(1) : normalized;
  const [whole = '0', fraction = ''] = unsigned.split('.');
  const centavos = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
  return assertMoney(negative ? -centavos : centavos);
}

export function formatBRL(value: Money, includeSymbol = true): string {
  const sign = value < 0n ? '-' : '';
  const magnitude = value < 0n ? -value : value;
  const whole = magnitude / 100n;
  const cents = (magnitude % 100n).toString().padStart(2, '0');
  const grouped = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${sign}${includeSymbol ? 'R$\u00a0' : ''}${grouped},${cents}`;
}

export function ratioBasisPoints(part: Money, whole: Money): number | undefined {
  if (whole <= 0n) return undefined;
  const scaled = (part * 10_000n) / whole;
  if (scaled > BigInt(Number.MAX_SAFE_INTEGER)) return Number.MAX_SAFE_INTEGER;
  if (scaled < BigInt(Number.MIN_SAFE_INTEGER)) return Number.MIN_SAFE_INTEGER;
  return Number(scaled);
}

export function formatPercentBasisPoints(value: number | undefined): string {
  if (value === undefined) return '—';
  return `${(value / 100).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;
}

